import PropTypes from 'prop-types';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: PropTypes.node,
};

export default function CardText({ children }) {
  return (
    <div className="pr-10 text-base text-gray-500 lg:pr-20 lg:text-lg">
      {children}
    </div>
  );
}

CardText.defaultProps = defaultProps;
CardText.propTypes = propTypes;
